import React from "react";
import { LedgerRecord } from "../../../services/interfacev2";
import { useNavigate } from "react-router-dom";
import { formatNumber } from "src/business-types/laundry/modules/orders/OrderSearch";

interface Props {
  results: LedgerRecord[];
  onClose: () => void;
}

const LedgerSearchDropdown: React.FC<Props> = ({ results, onClose }) => {
  const navigate = useNavigate();

  if (results.length === 0) {
    return <p className="p-2">No data available</p>;
  }

  const getFullName = (item: LedgerRecord) => {
    const nameParts = [item.firstName, item.middleName, item.lastName].filter((part) => part && part !== "undefined" && part.trim() !== "");
    return nameParts.join(" ") || "Unnamed";
  };

  const getClientId = (item: LedgerRecord) => {
    const idNum = Number(item.clientId) || 0;
    return formatNumber(idNum);
  };

  const getPhoneNumber = (item: LedgerRecord) => {
    const phone = item.phones?.[0]?.phone;
    return phone && phone !== "undefined" ? phone : "No phone";
  };

  return (
    <div className="w-full overflow-y-auto max-h-[min(300px,40vh)]" id="ledger-header-table">
      {results.map((item, index) => (
        <div key={index} onClick={() => { navigate(`/v1/ledger/${item.customerId}`); onClose(); }}
          className="flex items-center px-4 py-3 hover:bg-gray-50 cursor-pointer border-b border-gray-100 last:border-b-0 transition-colors duration-150"
        >
          {/* Name - Left aligned with flex-1 to take available space */}
          <div className="flex-1 min-w-0">
            <p className="font-medium text-gray-800 text-sm break-words leading-relaxed" id="ledger-header-table-name">
              {getFullName(item)}
            </p>
          </div>

          {/* Client ID and Phone - Centered with fixed width */}
          <div className="flex items-center justify-center gap-6 flex-shrink-0 w-[240px]">
            <div className="text-center min-w-[80px]">
              <p className="text-gray-500 text-sm font-mono" id="ledger-header-table-clientid">
                {getClientId(item)}
              </p>
            </div>

            <div className="text-center min-w-[100px]">
              <p className="text-gray-500 text-sm font-mono" id="ledger-header-table-phn">
                {getPhoneNumber(item)}
              </p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default LedgerSearchDropdown;
